export default __webpack_public_path__ + "images/OH.48ce7c7.png";